module.exports = __webpack_public_path__ + "img/Warrior-gnome-m-70.885a5ac8.gif";